<template>
  <div class="search-bar"></div>
</template>

<style lang="scss" scoped>
.search-bar {
  background: var(--primary-white);
  border-radius: 8px;
  height: 154px;
}
</style>
